x
<template>
    <b-modal
        id="rubric-survey-show-module-add-students"
        :title="$t('rubrics.add_students')"
        ok-only
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal"
        size="xl"
        @show="onShow">
        <design-2021-apprentice-data-table
            :items="unselectedUsers"
            :fields="fields"
            :show-empty="true">
            <template v-slot:cell(action)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-add btn-open-group"
                        variant="primary-icon-only"
                        @click="addStudent(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('rubrics.all_students_have_been_added') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-show-module-add-student-modal-component',
    props: ['rubricSurveyIn'],
    data() {
        return {
            loaded: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('rubrics.student'),
                    sortable: true,
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            users: [],
        };
    },
    computed: {
        unselectedUsers() {
            return this.users.filter(
                (user) =>
                    !this.rubricSurveyIn.rubric_survey_users.some(
                        (rubricSurveyUser) => rubricSurveyUser.user_id === user.id,
                    ),
            );
        },
    },
    methods: {
        addStudent(userId) {
            let data = {
                user_id: userId,
            };

            this.alert.saving();
            this.axios.post(this.routes.rubricSurveyStudentsAdd(this.rubricSurveyIn.id), data).then(
                (response) => {
                    this.rubricSurveyIn.addRelation('rubric_survey_users', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onShow() {
            if (this.loaded) {
                return;
            }

            this.alert.loading();
            this.axios.get(this.routes.moduleUsers(this.rubricSurveyIn.rubric_surveyable_id)).then(
                (response) => {
                    this.users = response.data.users;
                    this.alert.loaded();
                    this.loaded = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.group-actions {
    display: flex;
    margin-right: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        font-size: 1.3125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}
</style>
